import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionDetailsCard = ({ transactionData }) => {
  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatTime = (date) => {
    return new Date(date)?.toLocaleTimeString('es-VE', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getPaymentMethodIcon = (method) => {
    switch (method) {
      case 'Pago Móvil': return 'Smartphone';
      case 'Zelle': return 'DollarSign';
      case 'Binance': return 'Bitcoin';
      case 'Transferencia': return 'CreditCard';
      default: return 'Banknote';
    }
  };

  const detailItems = [
    {
      icon: 'Hash',
      label: 'Número de Referencia',
      value: transactionData?.referenceNumber,
      highlight: true
    },
    {
      icon: getPaymentMethodIcon(transactionData?.paymentMethod),
      label: 'Método de Pago',
      value: transactionData?.paymentMethod
    },
    {
      icon: 'Building2',
      label: 'Banco Emisor',
      value: transactionData?.bankIssuer
    },
    {
      icon: 'Banknote',
      label: 'Monto Total',
      value: `Bs. ${transactionData?.amount?.toLocaleString()}`,
      highlight: true
    },
    {
      icon: 'ShoppingCart',
      label: 'Cantidad de Boletos',
      value: `${transactionData?.quantity} boleto${transactionData?.quantity > 1 ? 's' : ''}`
    },
    {
      icon: 'Calendar',
      label: 'Fecha de Transacción',
      value: formatDate(transactionData?.timestamp)
    },
    {
      icon: 'Clock',
      label: 'Hora de Transacción',
      value: formatTime(transactionData?.timestamp)
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-luxury">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={20} className="text-secondary" />
        </div>
        <div>
          <h3 className="text-xl font-heading font-bold text-gray-800"> {/* Cambiado aquí */}
            Detalles de la Transacción
          </h3>
          <p className="text-sm text-gray-800 font-caption"> {/* Cambiado aquí */}
            ID: {transactionData?.transactionId}
          </p>
        </div>
      </div>
      <div className="space-y-4">
        {detailItems?.map((item, index) => (
          <div key={index} className="flex items-center justify-between py-3 border-b border-border last:border-b-0">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-muted/30 rounded-lg flex items-center justify-center">
                <Icon name={item?.icon} size={14} className="text-gray-800" /> {/* Cambiado aquí */}
              </div>
              <span className="text-sm font-medium text-gray-800 font-body"> {/* Cambiado aquí */}
                {item?.label}
              </span>
            </div>
            <span className={`text-sm font-mono font-medium ${
              item?.highlight ? 'text-secondary' : 'text-gray-800' /* Cambiado aquí */
            }`}>
              {item?.value}
            </span>
          </div>
        ))}
      </div>
      {transactionData?.receiptUrl && (
        <div className="mt-6 pt-4 border-t border-border">
          <div className="flex items-center space-x-2 text-sm text-gray-800"> {/* Cambiado aquí */}
            <Icon name="Paperclip" size={14} className="text-gray-800" /> {/* Cambiado aquí */}
            <span>Comprobante adjunto</span>
          </div>
          <div className="mt-2 p-3 bg-muted/20 rounded-lg border border-border">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Icon name="Image" size={16} className="text-secondary" />
                <span className="text-sm font-medium text-gray-800"> {/* Cambiado aquí */}
                  comprobante_{transactionData?.referenceNumber}.jpg
                </span>
              </div>
              <button className="text-secondary hover:text-secondary/80 transition-premium">
                <Icon name="Download" size={16} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionDetailsCard;